export type DocumentItem = {
  id: string;
  label: string;
  tagName: string;
};

export type DocumentSection = {
  id: string;
  label: string;
  documents: DocumentItem[];
};

export const documentSections: DocumentSection[] = [
  {
    id: 'company-file',
    label: 'Company file',
    documents: [
      {
        id: 'company-file-corporation-papers',
        label: 'Corporation Papers',
        tagName: 'company_file_corporation_papers',
      },
      {
        id: 'company-file-ss-4',
        label: 'SS-4',
        tagName: 'company_file_ss_4',
      },
      {
        id: 'company-file-poa',
        label: 'POA',
        tagName: 'company_file_poa',
      },
      {
        id: 'company-file-certificate-of-insurance',
        label: 'Certificate of Insurance',
        tagName: 'company_file_certificate_of_insurance',
      },
      {
        id: 'company-file-drivers-license-owner',
        label: "Driver's License (Owner)",
        tagName: 'company_file_drivers_license_owner',
      },
      {
        id: 'company-file-sales-tax-certificate',
        label: 'Sales Tax Certificate',
        tagName: 'company_file_sales_tax_certificate',
      },
    ],
  },
  {
    id: 'authority',
    label: 'Authority',
    documents: [
      {
        id: 'authority-certificate-of-authority',
        label: 'Certificate of Authority',
        tagName: 'authority_certificate_of_authority',
      },
    ],
  },
  {
    id: 'registration',
    label: 'Registration',
    documents: [
      {
        id: 'registration-proofs-of-residency',
        label: 'Proofs of Residency',
        tagName: 'registration_proofs_of_residency',
      },
      {
        id: 'registration-vehicle-title-front-and-back',
        label: 'Vehicle Title - front and back',
        tagName: 'registration_vehicle_title_front_and_back',
      },
      {
        id: 'registration-2290',
        label: '2290',
        tagName: 'registration_2290',
      },
      {
        id: 'registration-motor-carrier-lease',
        label: 'Motor Carrier Lease',
        tagName: 'registration_motor_carrier_lease',
      },
      {
        id: 'registration-finance-lease',
        label: 'Finance Lease',
        tagName: 'registration_finance_lease',
      },
      {
        id: 'registration-other-documents',
        label: 'Other Documents',
        tagName: 'registration_other_documents',
      },
    ],
  },
  {
    id: 'dot-audit',
    label: 'DOT Audit',
    documents: [
      {
        id: 'dot-audit-company-questionnaire',
        label: 'Company Questionnaire (if applicable)',
        tagName: 'dot_audit_company_questionnaire',
      },
      {
        id: 'dot-audit-driver-list',
        label: 'Driver List',
        tagName: 'dot_audit_driver_list',
      },
      {
        id: 'dot-audit-equipment-list',
        label: 'Equipment List',
        tagName: 'dot_audit_equipment_list',
      },
      {
        id: 'dot-audit-mcs-90',
        label: 'MCS-90 (This is not the same as a certificate of insurance)',
        tagName: 'dot_audit_mcs_90',
      },
      {
        id: 'dot-audit-medical-certificate',
        label: 'Medical Certificate(s)',
        tagName: 'dot_audit_medical_certificates',
      },
      {
        id: 'dot-audit-mvr',
        label: 'MVR(s)',
        tagName: 'dot_audit_mvrs',
      },
      {
        id: 'dot-audit-employee-driver-licenses',
        label: 'Employee Driver Licenses',
        tagName: 'dot_audit_employee_driver_licenses',
      },
      {
        id: 'dot-audit-employee-applications',
        label: 'Employee Applications',
        tagName: 'dot_audit_employee_applications',
      },
      {
        id: 'dot-audit-previous-employer-verification',
        label: 'Previous Employer Verification',
        tagName: 'dot_audit_previous_employer_verification',
      },
      {
        id: 'dot-audit-vehicle-inspections',
        label: 'Vehicle Inspections',
        tagName: 'dot_audit_vehicle_inspections',
      },
      {
        id: 'dot-audit-drug-and-alcohol-enrollment',
        label: 'Drug & Alcohol Enrollment (If not enrolled with TFIG)',
        tagName: 'dot_audit_drug_and_alcohol_enrollment',
      },
      {
        id: 'dot-audit-proofs-of-accidents',
        label: 'Proofs of Accidents (if applicable)',
        tagName: 'dot_audit_proofs_of_accidents',
      },
      {
        id: 'dot-audit-company-policies-employee-handbook',
        label: 'Company Policies & Employee Handbook',
        tagName: 'dot_audit_company_policies_employee_handbook',
      },
      {
        id: 'dot-audit-inspector-qualification-files',
        label: 'Inspector Qualification Files',
        tagName: 'dot_audit_inspector_qualification_files',
      },
      {
        id: 'dot-audit-eld-information-website',
        label: 'ELD Information - Website',
        tagName: 'dot_audit_eld_information_website',
      },
      {
        id: 'dot-audit-eld-information-login',
        label: 'ELD Information - Login',
        tagName: 'dot_audit_eld_information_login',
      },
    ],
  },
];

export const documentTagNames = documentSections.flatMap((section) =>
  section.documents.map((document) => document.tagName),
);
